export const TransferTableHead = [
  "Sender name",
  "Email",
  "Amount",
  "Reciever name",
  "phone number",
  "Time",
  "Date",
];
